import React from "react";

function pendingIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 14.4C9.0913 14.4 10.6174 13.7257 11.7426 12.5255C12.8679 11.3253 13.5 9.69739 13.5 8C13.5 6.30261 12.8679 4.67475 11.7426 3.47452C10.6174 2.27428 9.0913 1.6 7.5 1.6C5.9087 1.6 4.38258 2.27428 3.25736 3.47452C2.13214 4.67475 1.5 6.30261 1.5 8C1.5 9.69739 2.13214 11.3253 3.25736 12.5255C4.38258 13.7257 5.9087 14.4 7.5 14.4ZM7.5 0C8.48491 0 9.46018 0.206926 10.3701 0.608964C11.2801 1.011 12.1069 1.60028 12.8033 2.34315C13.4997 3.08601 14.0522 3.96793 14.4291 4.93853C14.806 5.90914 15 6.94943 15 8C15 10.1217 14.2098 12.1566 12.8033 13.6569C11.3968 15.1571 9.48912 16 7.5 16C3.3525 16 0 12.4 0 8C0 5.87827 0.790176 3.84344 2.1967 2.34315C3.60322 0.842855 5.51088 0 7.5 0ZM7.875 4V8.2L11.25 10.336L10.6875 11.32L6.75 8.8V4H7.875Z"
        fill="#B1824F"
      />
    </svg>
  );
}

export default pendingIcon;
